// extracted by mini-css-extract-plugin
export default {"root":"Maps_root__VgIR5","container":"Maps_container__ArkGf","title":"Maps_title__kRvpL"};